const namedRoutes = {
  home: "/",
  about: "/about/",
  projects: "/projects/",
  article: (date, name) => `${date}/${name}/`,
};

export default namedRoutes;
